import React, { useEffect, useState } from "react";
import WebSocketConnection from "./WebSocketConnection";
import displayLogo from "../../../assets/images/display-logo.png";
import { Typography } from "antd";

const { Text } = Typography;

const DisplayContent = () => {
    const [upperContent, setUpperContent] = useState(null);
    const [payload, setPayload] = useState(null);

    const ShowStartContent = () => (
        <div style={{ background: 'white', color: 'red', width: '100%', height: '100%', paddingLeft: '100px', paddingRight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Text style={{fontSize: '80px', fontWeight: 'bold', textAlign: 'center', color: 'red', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                Who's ready to have the best fucking night of their lives?!
            </Text>
        </div>
    );

    const ShowEndContent = () => (
        <div style={{ background: 'black', color: 'white', width: '100%', height: '100%', paddingLeft: '100px', paddingRight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Text style={{fontSize: '80px', fontWeight: 'bold', textAlign: 'center', color: 'red', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                Show's over. Love you.
            </Text>
        </div>
    );

    const BucketPullContent = () => (
        <div style={{ background: 'white', color: 'black', width: '100%', height: '100%', paddingLeft: '100px', paddingRight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Text style={{fontSize: '100px', fontWeight: 'bold', textAlign: 'center', color: 'black', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {payload?.entry?.paperName}
            </Text>
        </div>
    );

    const CustomMessageContent = () => (
        <div style={{background: 'white', color: 'black', width: '100%', height: '100%', paddingLeft: '100px', paddingRight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Text style={{fontSize: '80px', fontWeight: 'bold', textAlign: 'center', color: 'black', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {payload?.message}
            </Text>
        </div>
    );

    const StandbyContent = () => (
        <div style={{background: 'black', color: 'grey', width: '100%', height: '100%', display: 'flex', alignItems: 'start', justifyContent: 'center'}}>
            <Text style={{marginTop: '20px', fontSize: '80px', fontWeight: 'bold', color: 'grey'}}>STANDBY</Text>
        </div>
    );


    useEffect(() => {
        console.log("payload in DisplayContent:", JSON.stringify(payload));
        switch (payload?.type) {
            case 'showStart':
                setUpperContent(<ShowStartContent/>);
                break;
            case 'showEnd':
                setUpperContent(<ShowEndContent/>);
                break;
            case 'bucketPull':
                setUpperContent(<BucketPullContent/>);
                break;
            case 'customMessage':
                setUpperContent(<CustomMessageContent />);
                break;
            default:
                setUpperContent(<StandbyContent />);
                break;
        }
    }, [payload]);

    return (
        <>
            <WebSocketConnection setPayload={setPayload} />
            <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                {payload?.type === "bucketPull" &&
                    <div style={{backgroundColor: '#E82A00', flex: 2, maxHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <Text style={{fontSize: '80px', fontWeight: 'bold', color: 'white'}}>
                            YOUR NEXT BUCKET PULL:
                        </Text>
                    </div>
                }
                <div style={{backgroundColor: '#000', flex: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white'}}>
                    {upperContent}
                </div>
                <div style={{backgroundColor: '#E82A00', flex: 2, maxHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <img src={displayLogo} alt="Display Logo" style={{height: '80%'}}/>
                </div>
            </div>
        </>
    );
};

export default DisplayContent;
